import henceforthApi from "./henceforthApi";

export const upload_image_api = async (key, image) => {
  let apiRes;
  let err;
  try {
    apiRes = await henceforthApi.Common.uploadFile(key, image);
  } catch (error) {
    err = error;
  } finally {
    return {
      filename: apiRes?.file_name,
      message: apiRes?.message || err?.response?.body?.message,
    };
  }
};

export const handleDelete = async (id, cb) => {
  let apiRes;
  let err;
  try {
    apiRes = await henceforthApi["Content"].delete(id);
    cb();
  } catch (error) {
    err = error;
  } finally {
    return { message: apiRes?.message };
  }
};

export const userGender = {
  MALE: "Male",
  FEMALE: "Female",
  NO_PREFERENCE: "No preference",
};

export const userWeight = {
  KGS: "Kgs",
  LBS: "Lbs",
};

export const userHeight = {
  CMS: "Cms",
};

export const userStatus = {
  ACTIVATED: "Activated",
  DEACTIVATED: "Inactive",
  DELETED: "Deleted",
};

export const userRaceStatus = {
  JOINED: "Joined",
  READY_TO_GO: "Ready to go",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  INCOMPLETE: "Incomplete",
};

export const raceStatus = {
  PUBLIC: "Public",
  PRIVATE: "Private",
  MARATHON: "Marathon",
  SOLO: "Solo",
  QUICK: "Quick",
  QUICK_ADMIN: "Quick",
};

export const raceStat = {
  UPCOMING: "Upcoming",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};
